import React, { useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
// import Fab from "@material-ui/core/Fab";
import IconButton from "@material-ui/core/IconButton";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import MicIcon from "@material-ui/icons/Mic";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
// import BallotIcon from "@material-ui/icons/Ballot";
// import Attachment from "@material-ui/icons/Attachment";
// import AttachFileSharpIcon from "@material-ui/icons/AttachFileSharp";
// import ImageIcon from "@material-ui/icons/Image";
import CameraIcon from "@material-ui/icons/Camera";
// import TripleIcon from "../../../bundle/images/svg/tripleIcon.svg"

export default function FabComponent({
  userLogin,
  shot,
  // medicalDocuments,
  // medicalInstructions,
  handleOpenFileUploadDialog,
  handleOpenVoiceRecorderDialog,
  handleOpenVideoeRecorderDialog,
  // handleOpenCompressedImageDialog,
  setAttachTypeDefault,
  AudienceID,
  VisitToken,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <div
        className={
          userLogin && userLogin.approve === "doctor"
            ? "send-files send-files-dr"
            : "send-files"
        }
        onClick={handleClick}
      // style={{ border: '1px solid red' }}
      >
        {userLogin && userLogin.approve === "doctor" ? (
          <div className="send-svg-files">
            <svg viewBox="0 0 448 512">
              <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" />
            </svg>
          </div>
        ) : (
          <>
            <div className="send-svg-files" style={{ width: '100%' }}>
              <svg viewBox="0 0 384 512">
                <path d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6v340zm-56-170h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" />
              </svg>
            </div>
            {/* <span>ارسال مستندات</span> */}
          </>
        )}
        {/* <AttachFileSharpIcon style={{ fontSize: 16 }} /> */}
        {/* <img style={{ fontSize: 16, width:100}} src={TripleIcon} /> */}
      </div>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            shot();
            setAttachTypeDefault();
            handleClose()
          }}
        >
          <IconButton aria-haspopup="true">
            <CameraIcon style={styles.btn} titleAccess="ارسال فایل" />
          </IconButton>
          <div style={{ width: '100%', textAlign: 'right' }}>
            دوربین
          </div>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleOpenFileUploadDialog();
            setAttachTypeDefault();
            handleClose()
          }}
        >
          <IconButton aria-haspopup="true">
            <AttachFileIcon style={styles.btn} titleAccess="ارسال فایل" />
          </IconButton>
          <div style={{ width: '100%', textAlign: 'right' }}>
            فایل
          </div>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleOpenVoiceRecorderDialog();
            setAttachTypeDefault();
            handleClose()
          }}
        >
          <IconButton aria-haspopup="true">
            <MicIcon style={styles.btn} titleAccess="ارسال فایل صوتی" />
          </IconButton>
          <div style={{ width: '100%', textAlign: 'right' }}>
            پیام صوتی
          </div>
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            handleOpenVideoeRecorderDialog();
            setAttachTypeDefault();
            handleClose()
          }}
        >
          <IconButton aria-haspopup="true">
            <CameraAltIcon
              style={styles.btn}
              titleAccess="ارسال پیام تصویری"
            />
          </IconButton>
          <div style={{ width: '100%', textAlign: 'right' }}>
            پیام ویدیویی
          </div>
        </MenuItem> */}
      </Menu>
    </div>
  );
}

const styles = {
  btn: {
    fontSize: 25,
    color: "#7144B7",
  },
};
